import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import AsyncSelect from 'react-select/async';



const API_URL = 'https://localhost:7102/api/CustomerApi';


const CustomerEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState('');
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [selectedUserType, setSelectedUserType] = useState(null);
    const [userTypeOptions, setUserTypeOptions] = useState([]);
    const [loading, setLoading] = useState(false); // Add loading state

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const [formData, setFormData] = useState({
        ID: '',
        CompanyID: '',
        CustomerTypeID: '',
        CustomerName: '',
        ContactNumber1: '',
        ContactNumber2: '',
        AddressLine1: '',
        AddressLine2: '',
        Remarks: '',
        LandMark: '',
        Town: '',
        District: '',

        State: '',
        Country: '',
        PostalId: '',
        PinCode: '',
        GPSLocation: '',
        ContactPerson: '',
        GSTNumber: '',
        Email: '',
        Route: '',
        PaymentType: '',
        PaymentTypeId: '',
        Gst: false,
        isSubmit: false,
        RouteSequenceNo: '',
        openingTime: '',
        lunchBreak: '',
        customerReview: '',
        TallyId: '',

    });


    //customer Route

    const [selectedRoute, setSelectedRoute] = useState("");
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRouteType, setSelectedRouteType] = useState("");


    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111' && response.response_data?.length) {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name,
                }));
                setRouteOptions(options);
            } else {
                console.warn('No routes found or invalid response:', response);
            }
        } catch (error) {
            console.error('Error fetching routes:', error);
        }
    };



    const handleRouteTypeChange = (selectedOption) => {
        setSelectedRouteType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            RouteID: selectedOption ? selectedOption.value : null,
        }));
    };

    useEffect(() => {
        fetchRouteTypes();
    }, []);


    const [pinCode, setPostcodes] = useState("");

    const [contactPersons, setcontactPersons] = useState("");
    const [districts, setDistricts] = useState("");
    const [states, setStates] = useState("");
    const [countrys, setCountrys] = useState("");


    const [openingTime, setOpeningTime] = useState("");

    const [lunchBreak, setLunchBreak] = useState("");
    const [selectedReviewStars, setSelectedReviewStars] = useState(0);

    const [customerReview, setCustomerReview] = useState(0); // ✍️ Customer review


    //pincode
    const [pinCodess, setPinCodess] = useState([]);
    const [selectedPinOption, setSelectedPinOption] = useState(null);

    const fetchPinOptions = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) return [];
        try {
            const response = await fetchData('PinCodeApi', `/${companyId}/${inputValue}`, token);
            if (response && Array.isArray(response)) {
                setPinCodess(response);
                return response.map(item => ({
                    value: item.id,
                    label: item.postcode,
                }));
            }
        } catch (error) {
            console.error('Error fetching PIN codes:', error);
        }
        return [];
    };

    const handlePinCodeSelect = (selected) => {
        setSelectedPinOption(selected);
        if (!selected) {
            setFormData(prevData => ({
                ...prevData,
                pinCode: '',
                town: '',
                district: '',
                state: '',
                country: '',
            }));
            return;
        }
        const detail = pinCodess.find(pc => pc.id === selected.value);
        if (detail) {
            setFormData(prevData => ({
                ...prevData,
                pinCode: detail.postcode || '',
                town: detail.city || prevData.town,
                district: detail.district || '',
                state: detail.state || '',
                country: detail.country || '',
            }));
        }
    };

    //payment

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");
    const handleChangepay = (event) => {
        setSelectedPaymentType(event.target.value);

    };

    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");

    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('PaymentMethodApi', `/${companyId}`, token);
            if (response.responseCode === '1111' && response.response_data?.length) {
                const options = response.response_data.map(accType => ({
                    value: accType.Id,
                    label: accType.Name,
                }));
                setPaymentmethodOptions(options);
            } else {
                console.warn('No payment methods found or invalid response:', response);
            }
        } catch (error) {
            console.error('Error fetching payment methods:', error);
        }
    };
    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            PaymentTypeId: selectedOption ? selectedOption.value : null,
        }));
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
        fetchCustomerTypes();
    }, []);


    useEffect(() => {
        setLoading(true); // Start loading
        console.log('Loading started');
        fetchData('CustomerApi', `/CustomerEdit/${id}`, token)
            .then((response) => {
                console.log('Fetch success:', response);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                    const selectedOption = paymentmethodOptions.find(option => option.value === response.response_data.PaymentTypeId);
                    const selectedRouteoption = routeOptions.find(option => option.value === response.response_data.RouteID);
                    const selectedCustomerTypeoption = customerTypeOptions.find(option => option.label === response.response_data.customerType);

                    setSelectedPaymentmethodType(selectedOption);
                    setSelectedRouteType(selectedRouteoption);
                    setSelectedCustomerType(selectedCustomerTypeoption);
                    // ⭐️ Set Star Rating (Ensure API returns reviewStars)
                    setCustomerReview(response.response_data.customerReview || 0);
                    // Set pincode dropdown display value
                    if (response.response_data.pinCode) {
                        setSelectedPinOption({ value: response.response_data.pinCode, label: response.response_data.pinCode });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching Location Details:', error);
            })
            .finally(() => {
                console.log('Loading stopped');
                setLoading(false); // Stop loading
            });
    }, [id]);




    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const [isGSTChecked, setIsGSTChecked] = useState(false);

    const handleGSTChange = (event) => {
        setIsGSTChecked(event.target.checked);
    };
    //customer type

    const [customerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");

    const fetchCustomerTypes = async () => {
        try {
            const response = await fetchData('CustomerTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(customer => ({
                    value: customer.id,
                    label: customer.type
                }));
                setCustomerTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Customer Types:', error);
        }
    };

    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            customerTypeid: selectedOption ? selectedOption.value : null,
        }));
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const updatedData = {
            ...formData,
            UpdatedBy: userId,
            PaymentTypeId: selectedPaymentmethodType ? selectedPaymentmethodType.value : formData.PaymentTypeId,
            RouteID: selectedRouteType ? selectedRouteType.value : formData.RouteID,
            // Ensure address fields are included with correct casing
            Country: formData.country || formData.Country || '',
            District: formData.district || formData.District || '',
            State: formData.state || formData.State || '',
            PinCode: formData.pinCode || formData.PinCode || '',
            Town: formData.town || formData.Town || '',
            LandMark: formData.landMark || formData.LandMark || '',
        };

        updateData('CustomerSaleCategoryApi', `${id}`, updatedData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/CustomerIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ width: '100%' }}>
            <form onSubmit={handleSubmit}>

                <div className='w-full mb-2 flex items-center'>
                    <h6 className='uppercase psheading flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>Customer ( {`${formData.name || ''} ${formData.customerCode || ''}`} )</h6>

                    {loading && (
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    )}


                    <Button
                        variant="contained"
                        style={{
                            marginLeft: '8px',
                            backgroundColor: '#ABBA7C',
                            color: 'white',
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }}
                        onClick={handleSubmit}
                    >
                        Update
                    </Button>
                    <Button
                        variant="contained"
                        component={Link}
                        to="/CustomerIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#FF8383' }}
                    >
                        Back
                    </Button>


                </div>
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}   
                {successMessage && <p className="text-green-500">{successMessage}</p>}
                <div className="w-full flex flex-wrap" style={{ backgroundColor: 'rgba(201, 222, 219, 0.5)', padding: '5px', borderRadius: '10px', marginTop: '10px', Width: '100%' }}>
                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Route
                            </label>
                            <Select
                                value={
                                    selectedRouteType ||
                                    (formData.route ? { value: formData.route, label: formData.route } : null)
                                }
                                onChange={handleRouteTypeChange}
                                options={routeOptions}
                                placeholder="RouteOptions"
                                isSearchable
                            />

                        </div>

                        <div className="w-1/4 mr-2">

                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                // value={formData.name}{formData.customerCode}}
                                //value={`${formData.name || ''} ${formData.customerCode || ''}`} 
                                value={formData.name}
                                onChange={handleChange}
                                name="name"
                                type="text"
                                placeholder="Enter Name"
                            />
                        </div>

                        <div className="w-1/4 mr-2">

                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Contact Person
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.contactPerson}
                                onChange={handleChange}
                                name="contactPerson"
                                type="text"
                                placeholder="Contact person"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Contact No:1
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.contactNumber1}
                                onChange={handleChange}
                                type="text"
                                name="contactNumber1"
                                placeholder="Contact Number 1"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Contact No:2
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.contactNumber2}
                                onChange={handleChange}
                                name="contactNumber2"
                                type="text"
                                placeholder="Contact Number 2"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Email
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.email} onChange={handleChange} name="email" type="text" placeholder="Email" />
                        </div>


                    </div>

                    <div className="w-full mb-4 flex" style={{ marginTop: '-1.0%' }}>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                GST Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.gstNumber} onChange={handleChange} name="gstNumber" maxLength={15} type="text" placeholder="GST Number" />
                        </div>


                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Address Line 1
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.addressLine1} onChange={handleChange} name="addressLine1" type="text" placeholder="Address Line 1" />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Address Line 2
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.adressLine2} onChange={handleChange} name="adressLine2" type="text" placeholder="Address Line 2" />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex" style={{ marginTop: '-1.0%' }}>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                PIN Code
                            </label>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={fetchPinOptions}
                                onChange={handlePinCodeSelect}
                                value={selectedPinOption || (formData.pinCode ? { value: formData.pinCode, label: formData.pinCode } : null)}
                                placeholder="Search PIN Code..."
                                isClearable
                            />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                LandMark
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.landMark || ''} onChange={handleChange} name="landMark" type="text" placeholder="Landmark" />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Town
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.town || ''} onChange={handleChange} name="town" type="text" placeholder="Town" />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                District
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.district || ''} onChange={handleChange} name="district" type="text" placeholder="District" />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                State
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.state || ''} onChange={handleChange} name="state" type="text" placeholder="State" />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Country
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.country || ''} onChange={handleChange} name="country" type="text" placeholder="Country" />
                        </div>
                    </div>
                    <div className="w-full mb-4 flex" style={{ marginTop: '-1.0%' }}>
                        <div className="w-1/6 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Payment Type
                            </label>
                            <Select
                                value={
                                    selectedPaymentmethodType ||
                                    (formData.paymentType ? { value: formData.paymentType, label: formData.paymentType } : null)
                                }
                                onChange={handlePaymentTypeChange}
                                options={paymentmethodOptions}
                                placeholder="PaymentOption"
                                isSearchable
                            />

                        </div>
                        <div className="w-1/6 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Customer Type
                            </label>
                            <Select
                                //value={selectedCustomerType}
                                value={selectedCustomerType || (formData.customerType ? { value: formData.customerType, label: formData.customerType } : '')}
                                onChange={handleCustomerTypeChange}
                                options={customerTypeOptions}
                                placeholder="Select Customer Type"
                                isSearchable
                            />
                        </div>
                        <div className="w-1/6 mr-2" >
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Opening Balance
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.openingBalance}
                                onChange={handleChange}
                                name="openingBalance"
                                type="text"
                                placeholder="Opening balance"
                            />
                        </div>
                        <div className="w-1/8 mr-2" >
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Route No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.routeSequenceNo}
                                onChange={handleChange}
                                name="routeSequenceNo"
                                type="text"
                                placeholder="Opening balance"
                            />
                        </div>

                        {/* Opening Time */}
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase text-black tracking-wide text-xs font-bold mb-2">Opening & Closing Time</label>

                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.openingTime}
                                onChange={handleChange}
                                name="openingTime"
                                type="text" />

                        </div>


                        {/* Lunchbrk Time */}
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase text-black tracking-wide text-xs font-bold mb-2">LunchBreak Time</label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.lunchBreak}
                                onChange={handleChange}
                                type="text"
                                name="lunchBreak" />

                        </div>

                        {/* Customer Review Stars */}
                        <div className="w-1/6 mr-2">
                            <label className="block uppercase text-black tracking-wide text-xs font-bold mb-2" htmlFor="closingTime">
                                Customer Rating
                            </label>
                            {/* <div className="flex">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                        key={star}
                                        className={`cursor-pointer text-2xl ${Number(star) <= Number(customerReview) ? 'text-yellow-400' : 'text-gray-600'}`}
                                        onClick={() => setCustomerReview(star)}
                                        value={formData.customerReview}

                                    >
                                        ★
                                    </span>

                                ))}
                            </div> */}
                            <div className="flex">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                        key={star}
                                        className={`cursor-pointer text-2xl ${Number(star) <= Number(formData.customerReview) ? 'text-yellow-400' : 'text-gray-600'}`}
                                        onClick={() => setFormData(prevData => ({ ...prevData, customerReview: star }))}
                                    >
                                        ★
                                    </span>
                                ))}
                            </div>

                        </div>

                    </div>
                    <div className="w-1/2 mr-2" style={{ marginTop: '-1.0%' }}>
                        <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            Remarks
                        </label>
                        <textarea
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.remarks}
                            onChange={handleChange}
                            name="remarks"
                            type="text"
                            row={1}
                        />
                    </div>
                    <div className="flex items-center">
                        <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            <input type="radio" name="PaymentType" value="1"
                                checked={selectedPaymentType === "1"}
                                onChange={handleChange} />
                            Credit
                        </label>
                        <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            <input type="radio" name="PaymentType" value="2"
                                checked={selectedPaymentType === "2"}
                                onChange={handleChange} />
                            Debit
                        </label>

                        <div className="flex items-center mt-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                <input
                                    type="checkbox"
                                    name="Gst"
                                    checked={formData.Gst}
                                    onChange={handleChange} // Use handleChange for consistency
                                />
                                GST
                            </label>
                        </div>
                    </div>
                </div>
            </form >
        </div >

    );
};

export default CustomerEdit;
